const operatorsTable = [
    {
        operator_id: '001',
        firstName: 'Michel',
        lastName: 'Glup',
        tags: ['class2']
    },
    {
        operator_id: '002',
        firstName: 'Colette',
        lastName: 'Dupuy',
        tags: ['class3']
    },
    {
        operator_id: '003',
        firstName: 'Zacharie',
        lastName: 'Frappier',
        tags: ['class2']
    },
    {
        operator_id: '0024',
        firstName: 'Aloin',
        lastName: 'Brunault',
        tags: ['class1']
    }
];

const piReceptorTable = [
    {
        id: '0b209138-5675-4590-9b0b-78d8a8095c46',
        name: 'machine 1',
        tags: ['prepa']
    },
    {
        id: '813c1938-8f89-435e-8944-7c9ab18893c4',
        name: 'machine 2',
        tags: ['process']
    },
    {
        id: 'f80b1ae7-04c5-4ae2-8c05-8317a01bf8ab',
        name: 'machine 3',
        tags: ['prepa']
    },
    {
        id: '086d7c24-1747-4587-a139-3c8cb18eccc1',
        name: 'machine 4',
        tags: ['process']
    },
    {
        id: '1715081e-ae70-4948-aab6-866e88f1dc1f',
        name: 'machine 5',
        tags: ['test']
    },
];

const opFabTable = [
    {
        id: '0b209138-5675-4590-9b0b-78d8a8095c46',
        name: 'OF-24-Z',
        start: 'Thu Aug 29 2019 08:00:00 GMT+0200 (Central European Summer Time)',
        end: 'Thu Aug 29 2019 11:00:00 GMT+0200 (Central European Summer Time)', 
        operators: ["001", "002"],
        productionZone: ['0b209138-5675-4590-9b0b-78d8a8095c46', '813c1938-8f89-435e-8944-7c9ab18893c4'],
        tags: ['prepa']
    },
    {
        id: '0b209138-5675-4590-Adfr-78d8a8095c46',
        name: 'OF-25-Z',
        start: 'Thu Aug 29 2019 14:00:00 GMT+0200 (Central European Summer Time)',
        end: 'Thu Aug 29 2019 17:00:00 GMT+0200 (Central European Summer Time)', 
        operators: ["003", "002"],
        productionZone: ['f80b1ae7-04c5-4ae2-8c05-8317a01bf8ab'],
        tags: ['box', 'test']
    },
    {
        id: '0azer38-5675-4590-Adfr-78d8a8095c46',
        name: 'OF-26-Z',
        start: 'Thu Aug 5 2019 14:00:00 GMT+0200 (Central European Summer Time)',
        end: 'Thu Aug 5 2019 17:00:00 GMT+0200 (Central European Summer Time)', 
        operators: ["003", "002"],
        productionZone: ['f80b1ae7-04c5-4ae2-8c05-8317a01bf8ab'],
        tags: ['box', 'test', 'green']
    },
    {
        id: '0azer38-5675-4590-Adfr-7rT8a8095dEc',
        name: 'OF-45-Z',
        start: 'Thu Aug 5 2019 14:00:00 GMT+0200 (Central European Summer Time)',
        end: 'Thu Aug 5 2019 17:00:00 GMT+0200 (Central European Summer Time)', 
        operators: ["003", "002"],
        productionZone: ['f80b1ae7-04c5-4ae2-8c05-8317a01bf8ab'],
        tags: ['box', 'test', 'green']
    },
    {
        id: 'wt7UvTf-5675-4590-Adfr-7rT8a8095dEc',
        name: 'OF-12-Z',
        start: 'Thu Aug 5 2019 14:00:00 GMT+0200 (Central European Summer Time)',
        end: 'Thu Aug 5 2019 17:00:00 GMT+0200 (Central European Summer Time)', 
        operators: ["003", "002"],
        productionZone: ['f80b1ae7-04c5-4ae2-8c05-8317a01bf8ab'],
        tags: ['box', 'test', 'yellow']
    },
    {
        id: 'wt7UvTf-5675-4590-Adfr-7rT8a8095dEc',
        name: 'OF-78-Z',
        start: 'Thu Sep 15 2019 14:00:00 GMT+0200 (Central European Summer Time)',
        end: 'Thu Sep 15 2019 17:00:00 GMT+0200 (Central European Summer Time)', 
        operators: ["003", "002", "001"],
        productionZone: ['f80b1ae7-04c5-4ae2-8c05-8317a01bf8ab'],
        tags: ['box', 'yellow']
    }
];

const tagList = [ 'box', 'yellow', 'test', 'green', 'prepa'];

let productTable = [
    {
        id: 'azer-123',
        name: 'Chariot 1',
        type: 'Chariot mecca',
        description: 'Marque: facom, Couleur gris, 247 outils...',
        beaconId: 'AEd657',
        tags: ['chariot', 'outils']
    },
    {
        id: 'qsdf-456',
        name: 'Poste mobile de soudure',
        type: 'Soudure',
        description: 'Marque: Elektro7, Couleur bleu',
        tags: ['soudure']
    }

]

export { operatorsTable, piReceptorTable, opFabTable, tagList, productTable };
